<template lang="html">
  <router-link :to="{ name: route }" style="width: 500px" :style="{ background: color }" class="ivu-card ivu-card-bordered lift-on-hover item-padding item-margin">
    <Row type="flex" align="middle" justify="space-between" class="content-area ivu-card-body">
      <Col span="20">
        <h2>{{ title }}</h2>
        <p>{{ content }}</p>
      </Col>
      <Col span="4">
        <Row type="flex" justify="end">
          <Icon type="arrow-right-c" size="30"></Icon>              
        </Row>
      </Col>
    </Row>
  </router-link>
</template>
<script>
export default {
  props: {
    color: { type: String, required: true },
    route: { type: String, required: true },
    title: { type: String, required: true },
    content: { type: String, required: true },
    direction: { type: String, required: true },
  },
  data() {
    const vm = this;
    return {
      sectionStyle: { background: vm.color },
      contentStyle: vm.direction === 'next' ? { 'text-align': 'right' } : { 'text-align': 'left' },
    };
  },
};
</script>
<style lang="css" scoped>
.content-area {
  padding: 16px;
  color: #fff;
}

.item-padding {
  padding: 16px;
}
.item-margin {
  margin: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/PageNavCard.vue